var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "submit-tender clearfix",
      staticStyle: { display: "inline-block" },
    },
    [
      _c(
        "modal",
        { ref: "alertSubmitModal", attrs: { modalId: "alert-submit-modal" } },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", { staticClass: "modal-pure-text" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("vendor.bid.submit.popupTitle")) + " "
              ),
            ]),
            _vm._v(" "),
            _vm.apprErrHint
              ? _c(
                  "span",
                  { staticClass: "form-error is-visible appr-error-message" },
                  [_vm._v("\n        " + _vm._s(_vm.apprErrHint) + "\n      ")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: {
                  type: "button",
                  "data-close": "",
                  "aria-label": "Close reveal",
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                staticClass: "btn btn--orange",
                attrs: { type: "submit" },
                on: {
                  click: function ($event) {
                    return _vm.submitBid()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.yesSubmit")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }